//import { decryptToken } from "./encryption";
import { decrypt } from "./encryption";

export const setTokenFromQuery = (search: string) => {

    const params = new URLSearchParams(search);
    let token = params.get('token');
    if (token) {
        token = token.replaceAll(' ', '+');
        sessionStorage.setItem('token', token);
    }
};


export const getToken = () => {

    var token = sessionStorage.getItem('token');
    if (token != null) {
        const decryptedToken = decrypt(token);
        return decryptedToken;
    }


};


